import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
export function HowItWorks() {
  const {
    ref,
    isVisible
  } = useScrollAnimation();
  const steps = [{
    num: '1',
    title: 'Diagnóstico Rápido',
    desc: 'Descarga el manual y lee los primeros dos capítulos de diagnóstico (15 min).'
  }, {
    num: '2',
    title: 'Micro-Protocolos',
    desc: 'Aplica los micro-protocolos MRN integrados en tu rutina actual (no necesitas tiempo extra).'
  }, {
    num: '3',
    title: 'Blindaje de Energía',
    desc: 'Sigue el blindaje de energía del Día 3 para que el agotamiento no regrese el lunes.'
  }];
  return <section className="py-24 px-4 bg-sage" data-id="element-81">
      <div ref={ref} className={`max-w-5xl mx-auto transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-82">
        <div className="text-center mb-16" data-id="element-83">
          <h2 className="text-3xl md:text-4xl font-serif text-teal mb-4" data-id="element-84">
            Cómo funciona
          </h2>
          <p className="text-charcoal max-w-2xl mx-auto" data-id="element-85">
            En los primeros 7 días de aplicar estos micro-reseteos, tu ventana
            de tolerancia se amplía. Lo notarás cuando el sonido de un juguete
            cayendo o una pregunta repetitiva ya no dispare una reacción de
            rabia, sino una respuesta calmada.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-86">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-1/6 right-1/6 h-0.5 bg-teal/20 -z-0" data-id="element-87"></div>

          {steps.map((step, index) => <div key={index} className="relative z-10 flex flex-col items-center text-center" data-id="element-88">
              <div className="w-24 h-24 bg-teal text-gold rounded-full flex items-center justify-center text-4xl font-serif mb-6 shadow-lg border-4 border-sage" data-id="element-89">
                {step.num}
              </div>
              <h3 className="text-xl font-serif text-teal mb-3" data-id="element-90">
                {step.title}
              </h3>
              <p className="text-charcoal/80" data-id="element-91">{step.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}